import MuiDivider, { DividerProps } from "@mui/material/Divider";
import { getStyleProps, passProps } from "modules/themes/styleUtils";

export const Divider = (props: DividerProps) => {
  return <MuiDivider {...passProps(props)} {...getStyleProps(props)} />;
};
